import {
  Box,
  Button,
  CheckIcon,
  Flex,
  JaneGoldIcon,
  TagFilledIcon,
  Typography,
} from '@jane/shared/reefer';

import styles from '../specialDetailStatus.module.css';

export interface SpecialDetailStatusFooterProps {
  footerSubtext?: string;
  footerText: string;
  isGold: boolean;
  onCheckoutClick: () => void;
  qualifyingStatus: string;
}
export const SpecialDetailStatusFooter = ({
  footerSubtext,
  footerText,
  isGold,
  onCheckoutClick,
  qualifyingStatus,
}: SpecialDetailStatusFooterProps) => {
  const isQualified = qualifyingStatus === 'qualified';
  const isApplied = qualifyingStatus === 'applied';

  if (!isQualified && !isApplied) return null;

  return (
    <Box p={24}>
      <Flex alignItems="center" pb={isApplied ? 16 : 0}>
        <Box background={isGold ? 'gold' : 'info'} borderRadius="xs" p={12}>
          {isGold && <JaneGoldIcon />}
          {!isGold && <TagFilledIcon color="grays-white" />}
        </Box>
        <Box mx={16}>
          <Typography variant="body-bold">{footerText}</Typography>

          {footerSubtext && (
            <Typography variant="mini" color="grays-mid">
              {footerSubtext}
            </Typography>
          )}
        </Box>
        <CheckIcon ml="auto" />
      </Flex>
      {isApplied && (
        <Button
          size="small"
          full
          label="Checkout now"
          onClick={onCheckoutClick}
          className={styles.border__radius__lg}
        />
      )}
    </Box>
  );
};
